import { Component, Input, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter, AfterViewInit, OnInit, Inject } from '@angular/core';
import { FileElement } from './model/file-element';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FileContentDialogComponent } from './modals/fileContentDialog/fileContentDialog.component';
import { DeleteDialogComponent } from './modals/deleteDialog/deleteDialog.component';

@Component({
  selector: 'file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.css']
})
export class FileManagerComponent implements OnInit, OnChanges, AfterViewInit {

  dataSource: MatTableDataSource<FileElement>;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['isFolder', 'name', 'lastModifiedDate', 'size'];

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: '0px', y: '0px' };

  constructor(public dialog: MatDialog) {
    this.dataSource = new MatTableDataSource();
  }

  @Input() fileElements: FileElement[];
  @Input() canNavigateUp: string;
  @Input() path: string;

  @Output() elementRemoved = new EventEmitter<FileElement>();
  @Output() navigatedDown = new EventEmitter<FileElement>();
  @Output() navigatedUp = new EventEmitter();

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.fileElements);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataSource = new MatTableDataSource(this.fileElements);
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit(): void {
    this.dataSource = new MatTableDataSource(this.fileElements);
    this.dataSource.sort = this.sort;
  }

  deleteElement(element: FileElement): void {
    this.elementRemoved.emit(element);
  }

  navigate(element: FileElement): void {
    if (element.isFolder) {
      this.navigatedDown.emit(element);
    }
  }

  navigateUp(): void {
    this.navigatedUp.emit();
  }

  openMenu(event: MouseEvent, element: FileElement): void {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'element': element };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }

  openDeleteDialog(element: FileElement) {
    let dialogRef = this.dialog.open(DeleteDialogComponent);
    let instance = dialogRef.componentInstance;
    instance.fileName =  this.path + element.name;
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.elementRemoved.emit(element);
      }
    });
  }

  openFileContentDialog(element: FileElement) {
    let dialogRef = this.dialog.open(FileContentDialogComponent);
    let instance = dialogRef.componentInstance;
    instance.content =  element.content;
  }

  formatSize(size: number): string {
    if (size === 0) {
      return '';
    } else {
      const i = Math.floor(Math.log(size) / Math.log(1024));
      return Number((size / Math.pow(1024, i)).toFixed(2)) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    }
  }

}
